var svgchart;
var sBalance = 0, sBalance1 = 0, sBalance2 = 0, sBalance3 = 0, sBalance4 = 0, lBalance = 0;
var sCp = 0, Cp1 = 0, Cp2 = 0, Cp3 = 0, Cp4 = 0, lCp = 0;
var Ds1 = 0, ds2 = 0, ds3 = 0, ds4 = 0, ds5 = 0, ds6 = 0;
var crInvestedZero = 0, crBalanceZero = 0;
var crInvested = 0, crCumulativePayments = 0, crInterest = 0, crCumulativeInterest = 0, crBalance = 0;
var prInvested = 0, prCumulativePayments = 0, prInterest = 0, prCumulativeInterest = 0, prBalance = 0;
var i = 0;
var CurrentAge, RetirementAge, YearsUntilRetirement, PresentValue, ExpectedAnnualReturn, AnnualPayment, AnnualPayment2;

function Graph1() {
	var chart;
	var highchartsOptions = Highcharts.setOptions(Highcharts.theme);
	chart = new Highcharts.Chart({
		chart: {
			renderTo: 'retirement-calculator__chart',
			type: 'line',
			marginRight: 10,
			marginBottom: 40,
			backgroundColor: 'rgb(240,240,240)'
		},
		title: {
			text: 'Retirement Balance'

		},
		subtitle: {
			text: '',
			x: -20
		},
		xAxis: {
			categories: [Ds1, ds2, ds3, ds4, ds5, ds6],
			title: {
				text: 'Age'
			}
		},
		plotOptions: {
			series: {
				color: '#008000'
			}
		},
		yAxis: {
			title: {
				text: 'Dollar Value'
			},
			plotLines: [{
				value: 0,
				width: 1,
				color: '#808080'
			}]
		},
		exporting: {
			buttons: {
				printButton: {
					enabled: false
				},
				exportButton: {
					enabled: false
				}
			}
		},
		legend: {
			enabled: true
		},
		legend: {
			layout: 'horizontal',
			align: 'right',
			verticalAlign: 'top',
			borderWidth: 0
		},
		series: [{
			name: 'Balance',
			data: [Number(sBalance), Number(sBalance1), Number(sBalance2), Number(sBalance3)]
		}]
	});
	svgchart =  chart.getSVG();
}

export function isNumberKey(evt, ctr, exp, dec) {
	if (isTextSelected(ctr)) ctr.value = "";
	var charCode = (evt.which) ? evt.which : event.keyCode
	if (charCode == 46 && ctr.value.indexOf('.') < 0 && Number(dec) > 0)
		return true;
	if (charCode > 31 && (charCode < 48 || charCode > 57))
		return false;
	if (ctr.value.indexOf('.') < 0 && String(ctr.value).length == Number(exp))
		return false;
	if (ctr.value.indexOf('.') >= 0) {
		var decindex = ctr.value.indexOf('.');
		var decstr = String(ctr.value).substr(decindex + 1, ctr.value.length - decindex);
		if (decstr.length == dec)
			return false;
	}
	return true;
}

function isTextSelected(input) {
	if (typeof input.selectionStart == "number") {
		return input.selectionStart == 0 && input.selectionEnd == input.value.length;
	}
	else if (typeof document.selection != "undefined") {
		input.focus();
		return document.selection.createRange().text == input.value;
	}
}

//for row one calculation
function CalculateInvested1() {
	if (Number(i) <= Number(AnnualPayment2)) {
		crInvested = Number(AnnualPayment);
	}
	else {
		crInvested = 0;
	}
}

function CalculateCumulativePayments1() {
	crCumulativePayments = Number(crInvestedZero) + Number(crInvested);
}

function CalculateInterest1() {
	crInterest = (Number(crBalanceZero) * Number(ExpectedAnnualReturn)) / 100;
}

function CalculateCumulativeInterest1() {
	crCumulativeInterest = Number(prInterest) + Number(crInterest);
}

function CalculateBalance1() {
	crBalance = Number(crBalanceZero) + Number(crInvested) + Number(crInterest);
}

// for else condition calculation
function CalculateInvested() {
	if (Number(i) <= Number(AnnualPayment2)) {
		crInvested = Number(AnnualPayment);
	}
	else {
		crInvested = 0;
	}
}

function CalculateCumulativePayments() {
	crCumulativePayments = Number(prCumulativePayments) + Number(crInvested);
}

function CalculateInterest() {
	crInterest = (Number(prBalance) * Number(ExpectedAnnualReturn)) / 100;
}

function CalculateCumulativeInterest() {
	crCumulativeInterest = Number(crInterest) + Number(prCumulativeInterest);
}

function CalculateBalance() {
	crBalance = Number(prBalance) + Number(crInvested) + Number(crInterest);
}

export function CmdAdd_onclick() {
	CurrentAge = document.getElementById('t1').value;
	RetirementAge = document.getElementById('t2').value;
	if (Number(CurrentAge) > Number(RetirementAge)) {
		alert('Current Age Must Be Less Than Retirement Age.');
		return false;
	}
	YearsUntilRetirement = Number(RetirementAge) - Number(CurrentAge);
	var diff = Math.ceil(Number(YearsUntilRetirement) / 5);
	PresentValue = document.getElementById('t3').value;
	ExpectedAnnualReturn = document.getElementById('t4').value;
	AnnualPayment = document.getElementById('t5').value;
	AnnualPayment2 = document.getElementById('t6').value;
	var newTable, startTag, endTag;
	//Creating a new table
	startTag = "<TABLE id='mainTable'><TBODY><TR><TH style=\"WIDTH: 120px\">Year</TH>" +
	"<TH style=\"WIDTH: 120px\">Age</TH>" +
	"<TH style=\"WIDTH: 120px\">Rate</TH>" +
	"<TH style=\"WIDTH: 120px\">Invested <br/>(Payments)</TH>" +
	"<TH style=\"WIDTH: 120px\">Cumulative <br/>Payments</TH>" +
	"<TH style=\"WIDTH: 120px\">Interest</TH>" +
	"<TH style=\"WIDTH: 120px\">Cumulative <br/>Interest</TH>" +
	"<TH style=\"WIDTH: 120px\">Balance</TH></TR>"
	endTag = "</TBODY></TABLE>"
	newTable = startTag;
	//Add the Latest row
	for (i = 0; i <= Number(YearsUntilRetirement); i++) {
		if (i == 0) {
			crInvestedZero = PresentValue;
			crBalanceZero = PresentValue;
			newTable += "<TR><TD style=\"WIDTH: 120px\" ></TD>";
			newTable += "<TD style=\"WIDTH: 120px\" ></TD>";
			newTable += "<TD style=\"WIDTH: 120px\" ></TD>";
			newTable += "<TD style=\"WIDTH: 120px\" >" + Number(crInvestedZero).toFixed(2) + "</TD>";
			newTable += "<TD style=\"WIDTH: 120px\" ></TD>";
			newTable += "<TD style=\"WIDTH: 120px\" ></TD>";
			newTable += "<TD style=\"WIDTH: 120px\" ></TD>";
			newTable += "<TD style=\"WIDTH: 120px\" >$ " + Number(crBalanceZero) + "</TD></TR>";
		}
		else if (i == 1) {
			CalculateInvested1();
			CalculateCumulativePayments1();
			CalculateInterest1();
			CalculateCumulativeInterest1();
			CalculateBalance1();
			newTable += "<TR><TD style=\"WIDTH: 120px\" >" + i + "</TD>";
			newTable += "<TD style=\"WIDTH: 120px\" >" + CurrentAge + "</TD>";
			newTable += "<TD style=\"WIDTH: 120px\" >" + Number(ExpectedAnnualReturn).toFixed(3) + "%</TD>";
			newTable += "<TD style=\"WIDTH: 120px\" >" + Number(crInvested).toFixed(2) + "</TD>";
			newTable += "<TD style=\"WIDTH: 120px\" >" + Number(crCumulativePayments).toFixed(2) + "</TD>";
			newTable += "<TD style=\"WIDTH: 120px\" >" + Number(crInterest).toFixed(2) + "</TD>";
			newTable += "<TD style=\"WIDTH: 120px\" >" + Number(crCumulativeInterest).toFixed(2) + "</TD>";
			newTable += "<TD style=\"WIDTH: 120px\" >" + Number(crBalance).toFixed(2) + "</TD></TR>";
			Ds1 = CurrentAge;
			sBalance = Number(crBalance).toFixed(2);
			sCp = Number(crCumulativePayments).toFixed(2);
			prInvested = crInvested;
			prCumulativePayments = crCumulativePayments;
			prInterest = crInterest;
			prCumulativeInterest = crCumulativeInterest;
			prBalance = crBalance;
		}
		else {
			CalculateInvested();
			CalculateCumulativePayments();
			CalculateInterest();
			CalculateCumulativeInterest();
			CalculateBalance();
			newTable += "<TR><TD style=\"WIDTH: 120px\" >" + i + "</TD>";
			newTable += "<TD style=\"WIDTH: 120px\" >" + (Number(CurrentAge) + Number(i - 1)) + "</TD>";
			newTable += "<TD style=\"WIDTH: 120px\" >" + Number(ExpectedAnnualReturn).toFixed(3) + "%</TD>";
			newTable += "<TD style=\"WIDTH: 120px\" >" + Number(crInvested).toFixed(2) + "</TD>";
			newTable += "<TD style=\"WIDTH: 120px\" >" + Number(crCumulativePayments).toFixed(2) + "</TD>";
			newTable += "<TD style=\"WIDTH: 120px\" >" + Number(crInterest).toFixed(2) + "</TD>";
			newTable += "<TD style=\"WIDTH: 120px\" >" + Number(crCumulativeInterest).toFixed(2) + "</TD>";
			newTable += "<TD style=\"WIDTH: 120px\" >" + Number(crBalance).toFixed(2) + "</TD></TR>";

			if (Number(CurrentAge) + Number(i - 1) == Number(CurrentAge) + (Number(diff))) {
				ds2 = Number(CurrentAge) + Number(i - 1)
				sBalance1 = Number(crBalance).toFixed(2);
				Cp1 = Number(crCumulativePayments).toFixed(2);
			}

			if (Number(CurrentAge) + Number(i - 1) == Number(CurrentAge) + (2 * Number(diff))) {
				ds3 = Number(CurrentAge) + Number(i - 1)
				sBalance2 = Number(crBalance).toFixed(2);
				Cp2 = Number(crCumulativePayments).toFixed(2);
			}

			if (Number(CurrentAge) + Number(i - 1) == Number(CurrentAge) + (3 * Number(diff))) {
				ds4 = Number(CurrentAge) + Number(i - 1)
				sBalance3 = Number(crBalance).toFixed(2);
				Cp3 = Number(crCumulativePayments).toFixed(2);
			}

			if (Number(CurrentAge) + Number(i - 1) == Number(CurrentAge) + (4 * Number(diff))) {
				ds5 = Number(CurrentAge) + Number(i - 1)
				sBalance4 = Number(crBalance).toFixed(2);
				Cp4 = Number(crCumulativePayments).toFixed(2);
			}
			prInvested = crInvested;
			prCumulativePayments = crCumulativePayments;
			prInterest = crInterest;
			prCumulativeInterest = crCumulativeInterest;
			prBalance = crBalance;
			if (Number(CurrentAge) + (5 * diff) >= RetirementAge) {
				ds6 = RetirementAge;
				lBalance = Number(crBalance).toFixed(2);
				lCp = Number(crCumulativePayments).toFixed(2);
			}
		}
	}
	newTable += endTag;
	//Update the Previous Table With New Table.
	console.log( document.getElementById('retirement-calculator__table'), newTable );
	document.getElementById('retirement-calculator__table').innerHTML = newTable;
	document.getElementById('retirement-calculator__main').style.display = 'none';
	document.getElementById('retirement-calculator__result').style.display = 'block';
	document.getElementById('lc1').innerHTML = YearsUntilRetirement;
	document.getElementById('lc2').innerHTML = '$ ' + addCommas(String(Number(crBalance).toFixed(2)));
	document.getElementById('lc3').innerHTML = '$ ' + addCommas(String(Number(crCumulativePayments).toFixed(2)));
	document.getElementById('lc4').innerHTML = '$ ' + addCommas(String(Number(crCumulativeInterest).toFixed(2)));
	Graph1();
}

function addCommas(nStr) {
	nStr += '';
	var x = nStr.split('.');
	var x1 = x[0];
	var x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}
